import { OverlayElement, OverlayElementType } from "./OverlayElement";

export class PrepositionedSignatureOverlayElement extends OverlayElement {
    public Pin: string;
    public Token: string;

    public constructor(init?: Partial<PrepositionedSignatureOverlayElement>) {
        super(OverlayElementType.PrepositionedSignature);
        Object.assign(this, init);
    }
}
